import CiroSwitch from "../../shared/CiroSwitch";
import classNames from "classnames";

const AutopilotRunSkipContactsContainer = ({
  skipContactsYouveAlreadySeen,
  setSkipContactsYouveAlreadySeen,
}: {
  skipContactsYouveAlreadySeen: boolean;
  setSkipContactsYouveAlreadySeen: (
    skipContactsYouveAlreadySeen: boolean,
  ) => void;
}) => {
  return (
    <div className={classNames("flex", "items-center", "gap-2")}>
      <CiroSwitch
        checked={skipContactsYouveAlreadySeen}
        onChange={(checked) => setSkipContactsYouveAlreadySeen(checked)}
      />
      <span className="text-sm">Skip contacts you've already seen</span>
    </div>
  );
};

export default AutopilotRunSkipContactsContainer;
